// extracted by mini-css-extract-plugin
export default {"root":"BL445Eu6Qp"};